var InterceptorManager =
/** @class */
function () {
  function InterceptorManager() {
    this._int = [];
  }

  Object.defineProperty(InterceptorManager.prototype, "handlers", {
    get: function get() {
      return this._int;
    },
    enumerable: true,
    configurable: true
  });

  InterceptorManager.prototype.use = function (handler) {
    this._int.push(handler);

    return this._int.length - 1;
  };

  InterceptorManager.prototype.eject = function (id) {
    this._int.splice(id, 1);
  };

  return InterceptorManager;
}();

export { InterceptorManager };